import { lazy } from 'react';

// Lazy load all page components
const HRDashboard = lazy(() => import("pages/Dashboards/HR"));

// App Settings (Super Admin only)
const AppSettings = lazy(() => import("pages/AppSettings/index"));
const CompanySettings = lazy(() => import("pages/Companies/index"));
const Department = lazy(() => import("pages/Department/DepartmentList"));
const Designation = lazy(() => import("pages/Designation/DesignationList"));
const DesignationAssign = lazy(() => import("pages/Designation/AssignDesignation"));
const Role = lazy(() => import("pages/Role/RolesList"));
const RoleAssign = lazy(() => import("pages/Role/AssignRole"));

// Employee pages
const OnBoarding = lazy(() => import("pages/Employees/OnBoarding/FormWizard"));
const Employees = lazy(() => import("pages/Employees/EmployeeList"));
const EmployeeDetails = lazy(() => import("pages/Employees/EmployeeDetails"));
const EmployeeProfileDetails = lazy(() => import("pages/Employees/Profile/EmployeeDetails"));

// Attendance pages
const Attendance = lazy(() => import("pages/Attendance/AttendanceList"));
const SalesAttendance = lazy(() => import("pages/Attendance/SalesAttendance"));
const SalesVisitDetailsPage = lazy(() => import("pages/Attendance/SalesVisitDetails"));
const UserTrips = lazy(() => import("pages/Attendance/UserTrips"));
const TripDetails = lazy(() => import("pages/Attendance/TripDetails"));
const MainAttendance = lazy(() => import("pages/Attendance/MainAttendance"));
const GeofenceManagement = lazy(() => import("pages/Attendance/GeofenceManagement"));
const FacialRecognitionApproval = lazy(() => import("pages/Attendance/FacialRecognitionApproval"));
const AttendanceApprovals = lazy(() => import("pages/Attendance/AttendanceApprovals"));

// Anomaly Detection
const AnomalyDashboard = lazy(() => import("pages/AnomalyDetection/AnomalyDashboard"));
const EmployeePatternAnalysis = lazy(() => import("pages/AnomalyDetection/EmployeePatternAnalysis"));

// Crashlytics
const CrashlyticsDashboard = lazy(() => import("pages/Crashlytics/CrashlyticsDashboard"));

// Leaves
const Leaves = lazy(() => import("pages/Leaves/MyLeavesList"));
const LeaveApproval = lazy(() => import("pages/Leaves/LeaveApprovals"));
const ApplyForLeaves = lazy(() => import("pages/Leaves/ApplyForLeave"));
const LeaveBalance = lazy(() => import("pages/Leaves/LeaveBalance"));

// Expenses
const ExpensesList = lazy(() => import("pages/Expenses/ExpensesList"));
const ApplyForExpense = lazy(() => import("pages/Expenses/ApplyForExpense"));
const ExpensesApproval = lazy(() => import("pages/Expenses/ExpensesApproval"));
const ExpensePayout = lazy(() => import("pages/Expenses/ExpensePayout"));


// Petty Cash Management
const PettyCash = lazy(() => import("pages/PettyCash"));



// Loans
const LoanApprovals = lazy(() => import("pages/Loans/LoanApprovals"));

// Daily Updates
const DailyUpdatesForm = lazy(() => import("pages/DailyUpdates/DailyUpdateForm"));
const OverallUpdates = lazy(() => import("pages/DailyUpdates/OverallUpdates"));

// Payroll
const EmployeesSalaryPayroll = lazy(() => import("pages/SalaryPayroll/SalaryEmployeeList"));
const CreateEmployeeSalarySlip = lazy(() => import("pages/SalaryPayroll/CreateSalarySlip"));
const ViewAllSlipsList = lazy(() => import("pages/SalaryPayroll/ViewAllSlipsList"));
const ViewSalarySlip = lazy(() => import("pages/SalaryPayroll/ViewSalarySlip"));
const SalaryPaidReport = lazy(() => import("pages/SalaryPayroll/SalaryPaidReport"));

// Resumes
const Resume = lazy(() => import("pages/Resumes/ListView"));
const ResumeDetails = lazy(() => import("pages/Resumes/ResumeDetails"));
const PublicResumeSubmissionForm = lazy(() => import("pages/Resumes/PublicSubmissionForm"));
const EmployeeOnboarding = lazy(() => import("pages/Employees/EmployeeOnboarding"));

// Events - Certificate download (public)
const CertificateDownloadPage = lazy(() => import("pages/Events/CertificateDownloadPage"));
const InternOfTheMonthReveal = lazy(() => import("pages/Events/InternOfTheMonthReveal"));
const CyberGuard2026EventPage = lazy(() => import("pages/Events/CyberGuard2026EventPage"));

// Interviews
const CandidateInterview = lazy(() => import("pages/Interviews/CandidateInterview"));
const InterviewRecordings = lazy(() => import("pages/Interviews/InterviewRecordings"));
const InterviewManagement = lazy(() => import("pages/Interviews/InterviewManagement"));

// Contact Form
const ContactForm = lazy(() => import("pages/ContactForm/ListView"));

// Notification
const Notification = lazy(() => import("pages/Notification/NotificationList"));

// Feedback
const FeedbackManagement = lazy(() => import("pages/Feedback"));

// Help & Support
const HelpSupport = lazy(() => import("pages/HelpSupport"));

// Tickets
const MyTickets = lazy(() => import("pages/Tickets/MyTickets"));
const AllTickets = lazy(() => import("pages/Tickets/AllTickets"));
const CreateTicket = lazy(() => import("pages/Tickets/CreateTicket"));
const TicketDetails = lazy(() => import("pages/Tickets/TicketDetails"));
const UserTicketDetails = lazy(() => import("pages/Tickets/UserTicketDetails"));

// Engage
const Engage = lazy(() => import("pages/Chat"));

// Email
const EmailManagement = lazy(() => import("pages/EmailManagement"));

// Calendar
const DefaultCalendar = lazy(() => import("pages/Calendar/Default"));
const MonthGrid = lazy(() => import("pages/Calendar/MonthGrid"));
const MultiMonthStack = lazy(() => import("pages/Calendar/MultiMonthStack"));

// Notes
const Notes = lazy(() => import("pages/Notes"));

// Performance Review
const PerformanceReviewDashboard = lazy(() => import("pages/PerformanceReview/PerformanceReviewDashboard"));
const ReviewTemplates = lazy(() => import("pages/PerformanceReview/ReviewTemplates"));
const SelfReview = lazy(() => import("pages/PerformanceReview/SelfReview"));
const MyReviews = lazy(() => import("pages/PerformanceReview/MyReviews"));
const CreateReviewCycle = lazy(() => import("pages/PerformanceReview/CreateReviewCycle"));
const ManagerReviews = lazy(() => import("pages/PerformanceReview/ManagerReviews"));
const ManagerReviewDetail = lazy(() => import("pages/PerformanceReview/ManagerReviewDetail"));
const AdminReviews = lazy(() => import("pages/PerformanceReview/AdminReviews"));
const AdminReviewDetail = lazy(() => import("pages/PerformanceReview/AdminReviewDetail"));
const ReviewHistory = lazy(() => import("pages/PerformanceReview/ReviewHistory"));
const ReviewAnalytics = lazy(() => import("pages/PerformanceReview/ReviewAnalytics"));
const ReviewDetailView = lazy(() => import("pages/PerformanceReview/ReviewDetailView"));

// Weekly Learning
const WeeklyLearningForm = lazy(() => import("pages/WeeklyLearning/WeeklyLearningForm"));

// Module Assignment
const ModuleAssignment = lazy(() => import("pages/ModuleAssignment/ModuleAssignment"));
const ModuleManagement = lazy(() => import("pages/ModuleManagement/ModuleManagement"));
const QRCodeGenerator = lazy(() => import("pages/QRCode/QRCodeGenerator"));

// Search
const SearchPage = lazy(() => import("pages/Search/SearchPage"));

// PDF to CSV
const PdfToCsv = lazy(() => import("pages/PdfToCsv/PdfToCsv"));

// Tenant Management
const TenantManagement = lazy(() => import("pages/Tenants/TenantManagement"));
const TenantRegistration = lazy(() => import("pages/Tenants/TenantRegistration"));

// Employee Assets Management
const EmployeeAssetsManagement = lazy(() => import("pages/Employees/EmployeeAssetsManagement"));
const AssetForm = lazy(() => import("pages/Employees/AssetForm"));
const AssetDetails = lazy(() => import("pages/Employees/AssetDetails"));

// Invoices
const InvoiceListView = lazy(() => import("pages/Invoices/ListView"));
const InvoiceAddNew = lazy(() => import("pages/Invoices/AddNew"));
const InvoiceOverview = lazy(() => import("pages/Invoices/Overview"));

// Authentication
const Login = lazy(() => import("pages/Authentication/Login"));
const ResetPassword = lazy(() => import("pages/Authentication/ResetPassword"));
const Verification = lazy(() => import("pages/Authentication/Verify"));
const Logout = lazy(() => import("pages/Authentication/LogOut"));
const Register = lazy(() => import("pages/Authentication/Register"));
const VerifyEmail = lazy(() => import("pages/Authentication/VerifyEmail"));
const UserProfile = lazy(() => import("pages/Authentication/UserProfile"));

// Pages
const Account = lazy(() => import("pages/Pages/Account"));
const Settings = lazy(() => import("pages/Pages/Settings"));
const Pricing = lazy(() => import("pages/Pages/Pricing"));
const Faqs = lazy(() => import("pages/Pages/Faqs"));
const ContactUs = lazy(() => import("pages/Pages/ContactUs"));



// Export all lazy components
export {
  HRDashboard,
  CompanySettings,
  Department,
  Designation,
  DesignationAssign,
  Role,
  RoleAssign,
  OnBoarding,
  Employees,
  EmployeeDetails,
  EmployeeProfileDetails,
  Attendance,
  SalesAttendance,
  SalesVisitDetailsPage,
  UserTrips,
  TripDetails,
  MainAttendance,
  GeofenceManagement,
  FacialRecognitionApproval,
  AttendanceApprovals,
  AnomalyDashboard,
  EmployeePatternAnalysis,
  CrashlyticsDashboard,
  Leaves,
  LeaveApproval,
  ApplyForLeaves,
  LeaveBalance,
  ExpensesList,
  ApplyForExpense,
  ExpensesApproval,
  ExpensePayout,

  LoanApprovals,
  DailyUpdatesForm,
  OverallUpdates,
  EmployeesSalaryPayroll,
  CreateEmployeeSalarySlip,
  ViewAllSlipsList,
  ViewSalarySlip,
  SalaryPaidReport,
  Resume,
  ResumeDetails,
  PublicResumeSubmissionForm,
  CandidateInterview,
  InterviewRecordings,
  InterviewManagement,
  EmployeeOnboarding,
  ContactForm,
  Notification,
  FeedbackManagement,
  HelpSupport,
  MyTickets,
  AllTickets,
  CreateTicket,
  TicketDetails,
  UserTicketDetails,
  Engage,
  EmailManagement,
  DefaultCalendar,
  MonthGrid,
  MultiMonthStack,
  Notes,
  // Performance Review
  PerformanceReviewDashboard,
  ReviewTemplates,
  SelfReview,
  MyReviews,
  CreateReviewCycle,
  ManagerReviews,
  ManagerReviewDetail,
  AdminReviews,
  AdminReviewDetail,
  ReviewHistory,
  ReviewAnalytics,
  ReviewDetailView,
  // Weekly Learning
  WeeklyLearningForm,
  // Module Assignment
  ModuleAssignment,
  ModuleManagement,
QRCodeGenerator,
  // Search
  SearchPage,
  // PDF to CSV
  PdfToCsv,
  // Tenant Management
  TenantManagement,
  TenantRegistration,
  // Employee Assets Management
  EmployeeAssetsManagement,
  AssetForm,
  AssetDetails,
  // Invoices
  InvoiceListView,
  InvoiceAddNew,
  InvoiceOverview,
  // Petty Cash Management
  PettyCash,
  // Authentication
  Login,
  ResetPassword,
  Verification,
  Logout,
  Register,
  VerifyEmail,
  UserProfile,
  // Pages
  Account,
  Settings,
  Pricing,
  Faqs,
  ContactUs,
  // Events
  CertificateDownloadPage,
  InternOfTheMonthReveal,
  CyberGuard2026EventPage,
  // App Settings
  AppSettings,
};
